/* src/app/modules/display/components/menus/product-menu/building-blocks/menu-section/empty-section/empty-section.component.scss */
.empty-container {
  background: transparent;
}
/*# sourceMappingURL=empty-section.component.css.map */
